import { PortalRoutes } from "constants/routes";
import React from "react";
import { Route } from "react-router-dom";
import CadastroFormulacaoContainer from "../formulacao/views/formulationRegister/cadastroFormulacaoContainer";
import ConfigurationTabsContainer from "./views/configurationTabsContainer";
import ConfigurationsContainer from "./views/configurationsContainer";

function ConfigurationsRouter() {
  return (
    <>
      <Route
        exact
        component={ConfigurationsContainer}
        key="base"
        path={PortalRoutes.CONFIGURATIONS}
      />
      <Route
        exact
        component={ConfigurationTabsContainer}
        key="registrations"
        path={PortalRoutes.CONFIGURATIONS_REGISTRATIONS}
      />
      <Route
        component={CadastroFormulacaoContainer}
        key="formulation-edit"
        path={PortalRoutes.CONFIGURATIONS_EDIT_FORMULATION}
      />
    </>
  );
}

export default ConfigurationsRouter;
